<div class="voices" id="voices">
  <div class="container">
    <span class="badge-pill">{{ 'voices.badge' | translate }}</span>
    <h2 class="section-heading">{{ 'voices.heading' | translate }}</h2>
    <p class="section-subheading">{{ 'voices.subheading' | translate }}</p>

    <owl-carousel-o [options]="carouselOptions" class="voices-carousel">
      @for (testimonial of testimonials; track testimonial; let i = $index) {
      <ng-template carouselSlide [id]="'testimonial-' + i">
        <div class="testimonial-card">
          <div class="row align-items-center g-4">
            <div class="col-12 col-md-3 col-lg-2">
              <!-- TODO: replace with actual testimonial-1.png -->
              <img class="testimonial-avatar" [src]="testimonial.avatar" alt="{{ testimonial.nameKey | translate }}" loading="lazy" />
            </div>
            <div class="col-12 col-md-9 col-lg-10">
              <p class="testimonial-quote">&ldquo;{{ testimonial.quoteKey | translate }}&rdquo;</p>
              <p class="testimonial-name">{{ testimonial.nameKey | translate }}</p>
              <p class="testimonial-role">{{ testimonial.roleKey | translate }}</p>
              <!-- <img class="testimonial-rating" src="assets/images/svg-icons/testimonial-rating.svg" alt="" loading="lazy" /> -->
            </div>
          </div>
        </div>
      </ng-template>
      }
    </owl-carousel-o>
  </div>
</div>